import { GeneralErrorNotification } from '@storeOld/reducers/notification'
import type { Saga } from 'redux-saga'
import { call, delay, put } from 'redux-saga/effects'

const TightLoopBreak = 500

export function safeSagaWrapper(saga: Saga<[]>) {
  return function* safeSaga() {
    while (true) {
      try {
        yield call(saga)
        break
      } catch (err) {
        yield put(GeneralErrorNotification)
        console.error('Unhandled exception:', err)
        yield delay(TightLoopBreak)
      }
    }
  }
}
